/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClaimImageDTO } from './ClaimImageDTO';
import type { GetPublicClaimItemResponse } from './GetPublicClaimItemResponse';
import type { GetPublicShopResponse } from './GetPublicShopResponse';
import type { GetPublicStatusResponse } from './GetPublicStatusResponse';
export type GetPublicClaimDetailResponse = {
    claimNo?: string;
    importedAt?: string;
    appointmentAt?: string;
    brand?: string;
    version?: string;
    imei?: string;
    serialNumber?: string;
    battery?: number;
    defect?: string;
    lockType?: GetPublicClaimDetailResponse.lockType;
    items?: Array<GetPublicClaimItemResponse>;
    images?: Array<ClaimImageDTO>;
    shop?: GetPublicShopResponse;
    statusHistory?: Array<GetPublicStatusResponse>;
};
export namespace GetPublicClaimDetailResponse {
    export enum lockType {
        NONE = 'NONE',
        PIN = 'PIN',
        PASSWORD = 'PASSWORD',
        PATTERN = 'PATTERN',
    }
}

